module.exports = __webpack_public_path__ + "static/media/custom-15000-medium.d813109f.png";